import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-multi-select-checkbox',
  templateUrl: './multi-select-checkbox.component.html',
  styleUrls: ['./multi-select-checkbox.component.scss']
})
export class MultiSelectCheckboxComponent {
  @Input() label: string = '';
  @Input() options: { value: string; label: string }[] = [];
  @Input() selectedValues: string[] = [];
  @Output() selectionChanged = new EventEmitter<string[]>();

  toggleCheckbox(value: string) {
    if (this.selectedValues.includes(value)) {
      this.selectedValues = this.selectedValues.filter((v) => v !== value);
    } else {
      this.selectedValues.push(value);
    }
    this.selectionChanged.emit(this.selectedValues);
  }
}
